
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TdoImagePickerEvent } from './model/tdo-image-picker.event';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { DxPopoverModule, DxPopupModule, DxButtonModule, DxTemplateModule } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { DialogService } from '../../../services/dialog.service';




@Component({
  selector: 'app-tdo-image-picker',
  templateUrl: './tdo-image-picker.component.html',
  styleUrls: ['./tdo-image-picker.component.scss']
})
export class TdoImagePickerComponent implements OnInit {
  @Input() dataSource: string[];
  @Input() selectedImage: string = null;
  @Input() showLabel: boolean = true;
  @Input() popoverHeight: number = 290;
  @Input() path: string = 'src/assets/Images/image-picker/';

  //src\assets\Images\image-picker\iconToothNew.svg

  @Output() imageChange = new EventEmitter<TdoImagePickerEvent>();

  constructor(private dialogService: DialogService,) {
  }

  popupVisible: boolean = false;
  moreInfoButtonOptions: any;
  emailButtonOptions: any;
  closeButtonOptions: any;
  positionOf: string;

  ngOnInit(): void {
  }

  onIconButtonClick() {
    this.dialogService.openIconPicker().subscribe((result) => {
      if (result) {
        this.selectedImage = '/assets' + result.iconPath;
        this.imageChange.emit(new TdoImagePickerEvent(this.selectedImage));
      }
    });
  }
}
